module.exports = __webpack_public_path__ + "static-portal/img/news6-3.0e749bc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news6-3.png
// module id = mbKS
// module chunks = 4